import { render, staticRenderFns } from "./companyCoupon.vue?vue&type=template&id=ab4eab42&scoped=true"
import script from "./companyCoupon.vue?vue&type=script&lang=js"
export * from "./companyCoupon.vue?vue&type=script&lang=js"
import style0 from "./companyCoupon.vue?vue&type=style&index=0&id=ab4eab42&prod&lang=less"
import style1 from "./companyCoupon.vue?vue&type=style&index=1&id=ab4eab42&prod&lang=less&scoped=true"
import style2 from "./companyCoupon.vue?vue&type=style&index=2&id=ab4eab42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4eab42",
  null
  
)

export default component.exports